import { useState, useEffect } from "react";
import { axiosNoAuth } from "../config/axiosInstances";
import { Api_url } from '../common/api_url';
import { API_XANO_BASE_URL } from '../config/api_config';
import { userPlacements } from "../utils/userPlacementsData";

const getModalPage = async (pageParam = 1, options={}) => {
    const response = await axiosNoAuth.get(
        API_XANO_BASE_URL + Api_url.GetOurLearnersWorkAt + `?page=${pageParam}`, options
    )
    return response.data.data
}

const useModalData = (pageNum = 1) => {
    const [usersData, setUsersData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isError, setIsError] = useState(false)
    const [error, setError] = useState({})
    const [hasNextPage, setHasNextPage] = useState(false)

    useEffect(() => {
        setIsLoading(true)
        setIsError(false)
        setError({})

        const controller = new AbortController()
        const { signal } = controller



        const slicedData = userPlacements?.slice((pageNum-1)  * 10, pageNum * 10);


        setUsersData((prev) => ([...prev, ...slicedData]));
        setHasNextPage(Boolean(slicedData?.length))
        setIsLoading(false)
        // getModalPage(pageNum)
        // .then(result => {
        //     setUsersData((prev) => ([...prev, ...result]))
        //     setHasNextPage(Boolean(result.length))
        //     setIsLoading(false)

        // }).catch(e => {
        //     setIsLoading(false)
        //     if (signal.aborted) return
        //     setIsError(true)
        //     setError({message: e.message})
        // })

        return () => controller.abort()
    }, [pageNum])

    return {usersData, isLoading, isError, error, hasNextPage}
}

export default useModalData